import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap , concatMap} from 'rxjs/operators';
import * as OrganizationActions from './organization.actions';
import * as appActions from '../../app/app.actions';
import { OrganizationRequests } from './organization.requests';
import { AppService } from '@app/services/app/app.service';


@Injectable()
export class SettingsOrganizationEffects {

    constructor(
        private actions$: Actions,
        private orgReq: OrganizationRequests,
        private appSrv: AppService
    ) {}

    updateOrganization$ = createEffect(() =>
        this.actions$.pipe(
            ofType(OrganizationActions.updateOrganization),
            mergeMap(action =>
                this.orgReq.updateOrganization$(action.name).pipe(
                    concatMap(organization => {
                        this.appSrv.init()
                        return [OrganizationActions.updateOrganizationSuccess({ organization })];
                    }),
                    catchError((error) => {
                        console.error(error); // Log the error
                        return of(OrganizationActions.updateOrganizationError({ error }))// error handling
                    }) 
                )
            )
        )
    );

    uploadLogo$ = createEffect(() =>
        this.actions$.pipe(
            ofType(OrganizationActions.uploadLogo),
            mergeMap(action =>
                this.orgReq.uploadLogo$(action.fileId, action.options).pipe(
                    map(response => {
                        this.appSrv.init();
                        return OrganizationActions.uploadLogoSuccess({ response })
                    }),
                    catchError(error => {
                        console.error(error); // Log the error
                        return of(OrganizationActions.uploadLogoError({ error })); // error handling
                    })
                )
            )
        )
    );

    deleteLogo$ = createEffect(() =>
        this.actions$.pipe(
            ofType(OrganizationActions.deleteLogo),
            mergeMap(() =>
                this.orgReq.deleteLogo$().pipe(
                    map(response => {
                        return OrganizationActions.deleteLogoSuccess({ response })}),
                    catchError(error => {
                        console.error(error); // Log the error
                        return of(OrganizationActions.deleteLogoError({ error })); // Adjust error handling
                    })
                )
            )
        )
    );
}

